import React, {useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './styles/whatWeOffer.module.css';
import Card from "../../reusableComponents/cardComponent/Card";
import matchesImage from "../../../assets/images/matches.png";
import tablesImage from "../../../assets/images/tables.png";
import streamingImage from "../../../assets/images/streaming.png";
import votingImage from "../../../assets/images/Voting.png";
import highlightsImage from "../../../assets/images/highlights.png";
import newsImage from "../../../assets/images/news.png";
import bgimage1 from "../../../assets/images/Ellipse.png"
import bgimage2 from "../../../assets/images/Ellipse4.png"
import bgimage3 from "../../../assets/images/Ellipse3.png"

const whatWeOfferData = [
  {
    image: matchesImage,
    title: "Matches",
    description: "View upcoming battles and mark your calendar for unmissable dance-offs.",
    gradient: "default",
  },
  {
    image: tablesImage,
    title: "Tables",
    description: "View real-time rankings and follow your favorite teams' journey to the top.",
    gradient: "alternative",
  },
  {
    image: streamingImage,
    title: "Streaming",
    description:
      "Subscribe to Beats Fusion Premium for just $5 and stream all matches live without missing a beat of the action.",
    gradient: "default",
  },
  {
    image: votingImage,
    title: "Voting",
    description: "Support your favorite dance teams to the finale.",
    gradient: "alternative",
  },
  {
    image: highlightsImage,
    title: "Highlights",
    description: "Relive electrifying performances and unforgettable dance battles.",
    gradient: "default",
  },
  {
    image: newsImage,
    title: "News",
    description:
      "Get the latest news, updates, and interviews on the Beats Fusion league.",
    gradient: "alternative",
  },
];

const WhatWeOffer: React.FC = () => {

  useEffect(() => {
    AOS.init({ duration: 1200 }); // Initialize AOS with custom settings (e.g., duration of 1200ms)
  }, []);

  return (
    <div id="features"
      className="w-9/12 mx-auto relative bg-cover bg-center"
    >
      <div
        className={`hidden sm:block absolute top-0 right-0 z-0 ${styles.hideEllipses}`}
        style={{
          backgroundImage: `url(${bgimage1})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          width: '200px',
          height: '200px', 
          transform: 'translate(90%, -70%)', 
        }}
      ></div>

      <div
          className={`hidden sm:block absolute bottom-0 right-0 z-0 ${styles.hideEllipses}`}
          style={{
          backgroundImage: `url(${bgimage2})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          width: '190px', 
          height: '190px',
          transform: 'translate(89.5%, 70.5%)', 
          }}
      ></div>

      <div
          className={`hidden sm:block absolute bottom-0 left-0 z-0 ${styles.hideEllipses}`}
          style={{
          backgroundImage: `url(${bgimage3})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          width: '150px',
          height: '150px',
          transform: 'translate(-120%, 85%)', // Push it slightly outward to the left
          }}
      ></div>
      <h2 data-aos="fade-up" className={` ${styles.header_text} text-4xl sm:text-4xl md:text-5xl lg:text-7xl font-semibold text-center text-black mt-20 sm:mt-44`}>
        What we offer
      </h2>
      <p data-aos="fade-up" className="text-center text-md sm:text-base text-black mt-4 sm:mt-2">
        Dive into the rhythm! Stream live, catch up on news, vote for your favorites, and relive the best moments.
        <br className={styles.hideBreak} /> matches, tables, and highlights, your dance journey just got exhilarating!
      </p>


      <div className={`mt-12 sm:mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-16 ${styles.images_container}`}>
        {whatWeOfferData.map((offer, index) => (
          <Card
            key={index}
            image={offer.image}
            title={offer.title}
            description={offer.description}
            gradient="alternative"
            dataAos="zoom-in"
            dataAosDelay={`${ index * 200}`}
          />
        ))}
      </div>
    </div>
  );
};

export default WhatWeOffer;
